export default "__VITE_ASSET__CJmMUqjB__"